import React from 'react';
import { Info } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="flex flex-col items-center justify-between gap-4 border-t border-zinc-800/50 bg-zinc-900/40 px-4 py-4 md:flex-row md:px-8">
      <div className="flex items-center gap-4 md:gap-6">
        <div className="flex items-center gap-2 text-xs text-zinc-500">
          <Info className="h-3.5 w-3.5 text-blue-500" />
          <span>
            Sum(T<sub>c</sub>) = a × b<sup>c</sup>
          </span>
        </div>
        <div className="flex items-center gap-2 text-xs text-zinc-500">
          <div className="h-2 w-2 rounded-full bg-emerald-500" />
          <span>Symmetric Balance</span>
        </div>
      </div>
      <div className="font-mono text-[10px] tracking-widest text-zinc-600 uppercase">
        Algorithm by Jamiu Mojolagbe
      </div>
    </footer>
  );
};

export default Footer;
